import { InputFormTypeRadio } from "../../mod.ts";
import { RadioBlockItemType } from "@config/app/questionTemplates/types.ts";
import { InputFormTypeAllType } from "../../../types.ts";

export const RadioProfessionalStatus = (
  {
    value,
    data: {
      id,
      label,
      required,
      disabled,
      reference,
      content: {
        choices,
      },
    },
    onError,
    onSuccess,
    lastCheckedAt = 0,
  }: InputFormTypeAllType<{
    data: RadioBlockItemType;
  }>,
) => {
  return (
    <InputFormTypeRadio
      onSuccess={onSuccess}
      onError={onError}
      id={id}
      legend={label}
      direction={"column"}
      name={reference}
      fields={choices}
      value={value}
      isRequired={required}
      isDisabled={disabled}
      lastCheckedAt={lastCheckedAt}
    />
  );
};
